import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { CampaignEditFulfilledAction } from '../../domains/campaignEdit/actions.types';
import { CampaignLoadFulfilledAction } from '../../domains/campaigns/actions.types';
import { MyLeaderSponsoredCampaignsLoadFulfilledAction } from '../../domains/myLeaderSponsoredCampaigns/actions.types';

import { CampaignSponsorsEntities } from './types';

export type CampaignSponsorsAction =
  | CampaignLoadFulfilledAction
  | CampaignEditFulfilledAction
  | MyLeaderSponsoredCampaignsLoadFulfilledAction;

const initialState: CampaignSponsorsEntities = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<CampaignSponsorsEntities, CampaignSponsorsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CAMPAIGN.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignSponsors);
    case 'CAMPAIGN.EDIT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignSponsors);
    case 'MY_LEADER_SPONSORED_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignSponsors);
    default:
      return state;
  }
};

export default reducer;
